// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__v5s32","overlay":"modal_overlay__lgU22","container":"modal_container__lXrCX"};